class MasonryColumn {
  constructor(existing, getHeight) {
    this.members = existing || [];
    let height = 0;
    this.getHeight = getHeight;
    if (existing) {
      existing.map(el => {
        height += getHeight ? getHeight(el) : 1;
      });
    }
    this.height = height;
  }

  insert(item) {
    this.height += this.getHeight ? this.getHeight(item) : 1;
    this.members.push(item);
  }
}

export default MasonryColumn;
